import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import _ from 'lodash';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';

import Button from 'components/atoms/button';
import ArrowLink from 'components/atoms/arrowLink';
import { currency } from 'helpers/format';
import FormContent from 'components/organisms/formContent';
import FormActions from 'components/molecules/formActions';
import FormCol from 'components/molecules/formCol';
import FormTextArea from 'components/molecules/formTextArea/index.jsx';
import ExplainedCheckbox from 'components/molecules/explainedCheckbox/index.jsx';
import validate from '../validate';
import WizardProgress from 'components/organisms/wizard/progress';

import CollapsableSelectList from 'components/organisms/collapsableSelectList';
import CollapsableSelectListItem from 'components/molecules/collapsableSelectListItem';
import CollapsableSelectListItemHeader from 'components/atoms/collapsableSelectListItemHeader';

import ServiceListItem from 'components/molecules/serviceListItem';
import ServiceListItemHeader from 'components/atoms/serviceListItemHeader';
import ServiceListItemContent from 'components/atoms/serviceListItemContent';

import Modal from 'components/molecules/modal';

import serviceHelper from 'helpers/service';

class ServiceDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getServiceCategoryName(service) {
    return this.props.serviceCategories.reduce((result, category) => {
      return result || (category.id === service.service_category_id ? category : null);
    }, null);
  }

  totalAmount() {
    const total = !this.props.addons
      ? 0
      : this.props.addons.reduce((total, service) => {
          return service
            ? total +
                serviceHelper.price(service, {
                  legacyService: this.props.legacyService,
                })
            : total;
        }, 0);

    return this.props.services.reduce((total, service) => {
      return service
        ? total +
            serviceHelper.price(service, {
              legacyService: this.props.legacyService,
            })
        : total;
    }, total);
  }

  getCategory(service) {
    return _.find(this.props.serviceCategories, {
      id: service.service_category_id,
    });
  }

  render() {
    const service = this.props.services.reduce((result, service) => {
      return result || service;
    });

    const index = this.props.services.indexOf(service);

    const { handleSubmit, services, plusExplanation, legacyService, addonServices } = this.props;

    const { explainService } = this.state;

    return (
      <div className="serviceDetails">
        {explainService && (
          <Modal open onClose={() => this.setState({ explainService: null })}>
            <h6>{this.getCategory(explainService).name}</h6>
            <h3>{explainService.name}</h3>
            {legacyService !== true && <p>{explainService.description}</p>}

            {legacyService && <p>{explainService.alternative_description}</p>}
          </Modal>
        )}
        <Header inFlow />
        <WizardProgress step="2" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Confirma los servicios</h2>
              <p className="m">
                Asegurate de que no falte nada, podés dejarnos comentarios para aclarar cualquier
                detalle.
              </p>
              <FormContent nomargins>
                <form onSubmit={handleSubmit}>
                  <CollapsableSelectList>
                    {services.map((service, i) => {
                      const price = serviceHelper.price(
                        service,
                        { legacyService },
                        { plus: false }
                      );

                      return (
                        <ServiceListItem key={i}>
                          <ServiceListItemHeader
                            title={service.name}
                            secondaryInfo={currency(price)}
                          >
                            {service.description && (
                              <ArrowLink
                                style="blue"
                                size="small"
                                onClick={() => this.setState({ explainService: service })}
                              >
                                Explicación del servicio
                              </ArrowLink>
                            )}
                            <ArrowLink
                              style="blue"
                              size="small"
                              disabled={service.expanded}
                              onClick={() => {
                                service.expanded = !service.expaneded;
                                this.setState(this.state);
                              }}
                            >
                              Agregar comentarios
                            </ArrowLink>
                          </ServiceListItemHeader>
                          <ServiceListItemContent checked={service.expanded}>
                            <FormContent nomargins nobackground>
                              <FormCol twothird>
                                <FormTextArea
                                  last
                                  label="Comentarios"
                                  nolabel
                                  size="small"
                                  onChange={e => {
                                    service.comments = e.target.value;
                                  }}
                                  value={service.comments}
                                />
                              </FormCol>
                              <FormCol third>
                                <br />
                                <p className="s">
                                  Comenta cualquier detalle que quieras aclararnos par a que podamos
                                  brindarte el mejor servicio.
                                </p>
                                <br />
                                <ArrowLink
                                  style="blue"
                                  size="small"
                                  onClick={() => {
                                    service.comments = '';
                                    service.expanded = false;
                                    this.setState(this.state);
                                  }}
                                >
                                  Eliminar comentario
                                </ArrowLink>
                              </FormCol>
                            </FormContent>
                          </ServiceListItemContent>
                        </ServiceListItem>
                      );
                    })}

                    {services.map((service, i) => {
                      if (!service.price_plus) {
                        return;
                      }

                      const diff =
                        serviceHelper.price(service, { legacyService }, { plus: true }) -
                        serviceHelper.price(service, { legacyService }, { plus: false });

                      return (
                        <Field
                          component={ExplainedCheckbox}
                          name={`services[${i}].plus`}
                          key={i}
                          props={{
                            fieldValue: true,
                            toggleValue: false,
                            helpText: plusExplanation,
                            secondaryInfo: `${currency(diff)}`,
                            title: `${service.name} Plus`,
                          }}
                        />
                      );
                    })}

                    {this.props.brand === 'vw' && (
                      <Field
                        component={ExplainedCheckbox}
                        name="wants_dynamic_reception"
                        props={{
                          fieldValue: true,
                          toggleValue: null,
                          helpText:
                            'Inspeccionaremos y detectaremos necesidades de servicio. Requiere 15 minutos.',
                          title: 'Recepción dinámica',
                          secondaryInfo: 'Gratis',
                        }}
                      />
                    )}

                    {addonServices.length > 0 && (
                      <div>
                        <div className="addons">
                          Estos otros servicios también te podrían interesar:
                        </div>

                        {addonServices.map((service, i) => {
                          return (
                            <Field
                              component={ExplainedCheckbox}
                              name={`addons[${i}]`}
                              key={i}
                              props={{
                                fieldValue: service,
                                toggleValue: null,
                                helpText: service.description,
                                secondaryInfo:
                                  '+' +
                                  currency(
                                    serviceHelper.price(service, {
                                      legacyService,
                                    })
                                  ),
                                title: service.name,
                              }}
                            />
                          );
                        })}
                      </div>
                    )}
                  </CollapsableSelectList>
                  <FormActions back={this.props.previousPage}>
                    <CollapsableSelectList onFormActions>
                      <CollapsableSelectListItem>
                        <CollapsableSelectListItemHeader
                          secondaryInfo={currency(this.totalAmount())}
                          title="Total a pagar"
                          name="services"
                          infoOnly
                        />
                      </CollapsableSelectListItem>
                    </CollapsableSelectList>
                    <Button type="submit" buttonText="Continuar" />
                  </FormActions>
                </form>
              </FormContent>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

ServiceDetails = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ServiceDetails);

const selector = formValueSelector('shiftRequest');

ServiceDetails = connect(state => {
  return {
    services: selector(state, 'services'),
    addons: selector(state, 'addons'),
    legacyService: selector(state, 'legacy_service'),
  };
})(ServiceDetails);

const mapStateToProps = state => {
  return {
    serviceCategories: state.models.serviceCategories,
    addonServices: state.models.addonServices,
    plusExplanation: state.models.parameters.plus_explanation,
    brand: state.configuration.brand,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceDetails);
